/**
 * UI upgrades picked from the Waimers UI plan (preview page):
 *
 *  (H1 floating navbar was tried and turned off by the owner; its CSS and
 *  function are gone.)
 *  P1  Scroll-in story images - image-with-text photos start tilted back
 *      and stand upright as they scroll into view.
 *  K1  Free-shipping confetti - the moment the cart first crosses the free
 *      shipping threshold, a confetti burst and a note. Watches the cart
 *      endpoints themselves, so it works with the theme drawer or an app
 *      drawer. Once per cart.
 *  C1  Compare tray - "Compare" on collection cards; a tray collects up to 3
 *      products and opens a side-by-side table of their specs, read from
 *      each product through sections/compare-specs.liquid.
 *
 * All motion respects reduced motion.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* P1 ---------------------------------------------------------------- */
  function initStandUp() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.image-with-text__media:not(.image-with-text__media--placeholder)'));
    if (!items.length || reduce.matches) return;
    items.forEach(function (el) {
      el.classList.add('stand-up');
      if (el.parentElement) el.parentElement.classList.add('stand-up-stage');
    });
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var b = el.getBoundingClientRect();
        if (b.bottom < 0 || b.top > vh) return;
        var p = Math.max(0, Math.min(1, (vh - b.top) / (vh * 0.65)));
        el.style.setProperty('--stand', p.toFixed(3));
      });
    }
    // Straight on scroll, not via rAF: the work is a few class/style writes,
    // and rAF would stall the effect in a tab the browser has backgrounded.
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* K1 ---------------------------------------------------------------- */
  function initFreeShipping() {
    var threshold = parseInt(document.documentElement.getAttribute('data-free-shipping') || '0', 10);
    if (!threshold || !window.fetch) return;
    var KEY = 'waimers-free-ship-celebrated';
    var busy = false;

    function celebrated(token) {
      try { return sessionStorage.getItem(KEY) === token; } catch (e) { return false; }
    }
    function remember(token) {
      try { sessionStorage.setItem(KEY, token); } catch (e) { /* private mode */ }
    }

    function check() {
      if (busy) return;
      busy = true;
      window.setTimeout(function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            busy = false;
            if (!cart) return;
            if (cart.total_price >= threshold && !celebrated(cart.token)) {
              remember(cart.token);
              celebrate();
            }
          })
          .catch(function () { busy = false; });
      }, 250);
    }

    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(url)) {
        p.then(function () { check(); }, function () {});
      }
      return p;
    };
    document.addEventListener('cart:updated', check);
  }

  function celebrate() {
    var note = document.createElement('div');
    note.className = 'free-ship-note';
    note.setAttribute('role', 'status');
    note.textContent = 'You unlocked free shipping 🎉';
    document.body.appendChild(note);
    window.setTimeout(function () { note.classList.add('is-on'); }, 20);
    window.setTimeout(function () { note.classList.remove('is-on'); }, 3200);
    window.setTimeout(function () { note.remove(); }, 3800);
    if (reduce.matches) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var d = window.devicePixelRatio || 1;
    canvas.width = window.innerWidth * d;
    canvas.height = window.innerHeight * d;
    var ctx = canvas.getContext('2d');
    ctx.scale(d, d);
    var colours = ['#a97ee0', '#6c3baa', '#00fced', '#f5b301', '#ff6fae', '#3ccf8e'];
    var bits = [];
    for (var i = 0; i < 160; i++) {
      bits.push({
        x: window.innerWidth * (0.3 + Math.random() * 0.4),
        y: window.innerHeight * 0.55,
        vx: (Math.random() - 0.5) * 14,
        vy: -Math.random() * 14 - 6,
        r: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        s: 5 + Math.random() * 6,
        c: colours[i % colours.length]
      });
    }
    var frames = 0;
    (function tick() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      bits.forEach(function (b) {
        b.x += b.vx; b.y += b.vy; b.vy += 0.35; b.vx *= 0.99; b.r += b.vr;
        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.rotate(b.r);
        ctx.fillStyle = b.c;
        ctx.fillRect(-b.s / 2, -b.s / 4, b.s, b.s / 2);
        ctx.restore();
      });
      if (++frames < 150) window.requestAnimationFrame(tick);
      else canvas.remove();
    })();
  }

  /* C1 ---------------------------------------------------------------- */
  var CMP_KEY = 'waimers-compare';
  var MAX = 3;

  function readCmp() {
    try { return JSON.parse(sessionStorage.getItem(CMP_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeCmp(list) {
    try { sessionStorage.setItem(CMP_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  function initCompare() {
    var tray = null;

    function ensureTray() {
      if (tray) return tray;
      tray = document.createElement('div');
      tray.className = 'compare-tray';
      tray.innerHTML =
        '<div class="compare-tray__items" data-cmp-items></div>' +
        '<span class="compare-tray__hint" data-cmp-hint></span>' +
        '<button type="button" class="compare-tray__clear" data-cmp-clear>Clear</button>' +
        '<button type="button" class="btn btn--primary compare-tray__go" data-cmp-go>Compare</button>';
      document.body.appendChild(tray);
      tray.querySelector('[data-cmp-clear]').addEventListener('click', function () { writeCmp([]); sync(); });
      tray.querySelector('[data-cmp-go]').addEventListener('click', openTable);
      return tray;
    }

    function sync() {
      var list = readCmp();
      /* Re-queried each time: tab panels, filters and "load more" insert
         cards after load. */
      document.querySelectorAll('[data-compare-toggle]').forEach(function (t) {
        var on = list.some(function (x) { return x.handle === t.dataset.handle; });
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!list.length) { if (tray) tray.classList.remove('is-on'); return; }
      ensureTray();
      var items = tray.querySelector('[data-cmp-items]');
      items.textContent = '';
      list.forEach(function (x) {
        var chip = document.createElement('span');
        chip.className = 'compare-tray__chip';
        if (x.image) {
          var img = document.createElement('img');
          img.src = x.image;
          img.alt = '';
          chip.appendChild(img);
        }
        var name = document.createElement('span');
        name.textContent = x.title;
        chip.appendChild(name);
        items.appendChild(chip);
      });
      tray.querySelector('[data-cmp-hint]').textContent = list.length < 2 ? 'Pick one more to compare' : list.length + ' of ' + MAX + ' selected';
      tray.querySelector('[data-cmp-go]').disabled = list.length < 2;
      // A timeout, not rAF: rAF is paused in background tabs.
      window.setTimeout(function () { tray.classList.add('is-on'); }, 20);
    }

    /* Delegated, so toggles in cards inserted later (home tab panels,
       filtered or paginated grids) work too. Capture phase, so the card's
       own link handlers never see the click. */
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-compare-toggle]') : null;
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      var list = readCmp();
      var at = list.findIndex(function (x) { return x.handle === t.dataset.handle; });
      if (at !== -1) list.splice(at, 1);
      else {
        if (list.length >= MAX) list.shift();
        list.push({ handle: t.dataset.handle, title: t.dataset.title, image: t.dataset.image, url: t.dataset.url });
      }
      writeCmp(list);
      sync();
    }, true);

    /* New cards should show what is already picked. */
    var pendingSync = 0;
    new MutationObserver(function (records) {
      var added = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('[data-compare-toggle]') || n.querySelector('[data-compare-toggle]'));
        });
      });
      if (!added || pendingSync) return;
      pendingSync = window.setTimeout(function () { pendingSync = 0; sync(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });

    function openTable() {
      var list = readCmp();
      if (list.length < 2) return;
      var dialog = document.createElement('dialog');
      dialog.className = 'compare-dialog';
      dialog.innerHTML = '<div class="compare-dialog__head"><h2 class="h3">Compare</h2><button type="button" class="compare-dialog__close" aria-label="Close">✕</button></div><div class="compare-dialog__body"><p class="compare-dialog__loading">Loading specs…</p></div>';
      document.body.appendChild(dialog);
      dialog.showModal();
      function close() { dialog.close(); dialog.remove(); }
      dialog.querySelector('.compare-dialog__close').addEventListener('click', close);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('cancel', function () { window.setTimeout(function () { dialog.remove(); }, 0); });

      Promise.all(list.map(function (x) {
        return fetch(x.url.split('?')[0] + '?section_id=compare-specs', { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var m = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-compare-json]');
            try { return m ? JSON.parse(m.textContent) : null; } catch (e) { return null; }
          })
          .catch(function () { return null; });
      })).then(function (rows) {
        rows = rows.filter(Boolean);
        var labels = [];
        rows.forEach(function (r) {
          (r.specs || []).forEach(function (s) { if (labels.indexOf(s[0]) === -1) labels.push(s[0]); });
        });
        var table = document.createElement('table');
        table.className = 'compare-table';
        var head = '<thead><tr><th scope="col"><span class="visually-hidden">Spec</span></th>';
        rows.forEach(function (r) {
          head += '<th scope="col"><a href="' + r.url + '">' + (r.image ? '<img src="' + r.image + '" alt="">' : '') + '<span></span></a><strong></strong></th>';
        });
        head += '</tr></thead>';
        table.innerHTML = head + '<tbody></tbody>';
        var ths = table.querySelectorAll('thead th');
        rows.forEach(function (r, i) {
          ths[i + 1].querySelector('span').textContent = r.title;
          ths[i + 1].querySelector('strong').textContent = r.price;
        });
        var body = table.querySelector('tbody');
        labels.forEach(function (label) {
          var tr = document.createElement('tr');
          var th = document.createElement('th');
          th.scope = 'row';
          th.textContent = label;
          tr.appendChild(th);
          rows.forEach(function (r) {
            var td = document.createElement('td');
            var hit = (r.specs || []).filter(function (s) { return s[0] === label; })[0];
            td.textContent = hit ? hit[1] : '—';
            tr.appendChild(td);
          });
          body.appendChild(tr);
        });
        var wrapBody = dialog.querySelector('.compare-dialog__body');
        wrapBody.textContent = '';
        if (!rows.length) { wrapBody.textContent = 'Could not load the specs. Try again.'; return; }
        var scroller = document.createElement('div');
        scroller.className = 'compare-table-wrap';
        scroller.appendChild(table);
        wrapBody.appendChild(scroller);
      });
    }

    sync();
  }

  function init() {
    initStandUp();
    initFreeShipping();
    initCompare();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Marks page sections (inside <main>; the header, drawers, popups and dock
   live outside it and stay live; the newsletter is the one footer section
   added, for its meteor field) that are well off screen with
   data-offscreen, which pauses
   their CSS animations (end of assets/base.css). The margin keeps a section
   running while it is about to scroll into view, so nothing visibly restarts. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        entry.target.toggleAttribute('data-offscreen', !entry.isIntersecting);
      });
    },
    { rootMargin: '300px 0px' }
  );
  function watch(root) {
    (root || document).querySelectorAll('main .shopify-section, .shopify-section:has(.newsletter__inner)').forEach(function (section) {
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches('main .shopify-section, .shopify-section:has(.newsletter__inner)')) observer.observe(event.target);
  });
})();

/* Videos marked data-play-in-view (social-wall clips) ship without autoplay
   and with preload="none". They play while on screen and pause when they
   leave, so a wall of clips costs nothing until it is looked at. Reduced
   motion leaves the still in place. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;
  /* Pausing a video does not stop it downloading: Chrome keeps buffering
     the whole file at full speed, and a few paused clips starved every image
     below them (the community wall sat blank on desktop). Reloading with
     preload="none" aborts the fetch. A file that has fully arrived is left
     alone. */
  function stopVideo(video) {
    if (!video.paused) video.pause();
    /* Not only while actively loading: a download Chrome has suspended
       (networkState IDLE) keeps its HTTP/3 stream open, and those stalled
       streams fill the connection the page's images share. */
    if (video.readyState === HTMLMediaElement.HAVE_NOTHING) return;
    var buffered = video.buffered;
    if (buffered.length && video.duration && buffered.end(buffered.length - 1) >= video.duration - 0.5) return;
    video.preload = 'none';
    video.load();
    video.classList.remove('is-playing');
  }
  function watch(root) {
    var videos = (root || document).querySelectorAll('video[data-play-in-view]');
    if (!videos.length || reduce.matches || !('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && !document.hidden) {
              video.preload = 'auto';
              var playing = video.play();
              if (playing) playing.catch(function () {});
            } else {
              stopVideo(video);
            }
          });
        },
        { threshold: 0.25 }
      );
    }
    videos.forEach(function (video) {
      if (video.dataset.playWatched) return;
      video.dataset.playWatched = 'true';
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      });
      observer.observe(video);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  document.addEventListener('shopify:section:load', function (event) {
    watch(event.target);
  });
})();

/* Images marked data-load-early ship as loading="lazy" and are fetched
   ahead (see start) once their section is about four screens away. Plain lazy
   loading starts too late for images that sit hidden or off to the side in a
   moving track (they pop in as they appear); plain eager started them at
   page load, where they competed with the top of the page on phones. The
   section is observed, not the image, because those images are clipped or
   hidden and would never report as intersecting. Without JS they simply
   stay lazy. */
(function () {
  /* Fetches a detached copy rather than flipping the image to
     loading="eager". In Chrome, flipping a lazy image that is still off
     screen to eager stopped its lazy loader without ever starting the
     request, so on desktop the community wall stayed blank indefinitely.
     The real image stays lazy and, once it is in view, loads from the copy
     already in cache. The copy uses the same srcset and sizes, so it picks
     the same file. */
  var warmed = [];
  function start(scope) {
    scope.querySelectorAll('img[data-load-early]').forEach(function (img) {
      img.removeAttribute('data-load-early');
      var copy = new Image();
      if (img.sizes) copy.sizes = img.sizes;
      if (img.srcset) copy.srcset = img.srcset;
      copy.src = img.currentSrc || img.src;
      warmed.push(copy);
    });
  }
  function init() {
    var images = document.querySelectorAll('img[data-load-early]');
    if (!images.length) return;
    if (!('IntersectionObserver' in window)) return start(document);
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          start(entry.target);
        });
      },
      { rootMargin: '400% 0px' }
    );
    var seen = [];
    images.forEach(function (img) {
      var scope = img.closest('.shopify-section') || img.parentElement;
      if (seen.indexOf(scope) === -1) {
        seen.push(scope);
        observer.observe(scope);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });
})();
